"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GamblingSessionStatus = exports.GeolocationReason = exports.NativePluginStatus = exports.NativePermissionEnum = exports.LifecycleEnum = exports.AuthenticationServiceType = exports.EncryptionType = exports.NativeAppType = exports.CashierSessionType = exports.MyAccountTab = exports.SourceType = exports.ElementType = exports.PersonalLimitsPopupType = exports.UserMode = exports.MessageActionType = exports.ToastActionType = exports.ClientThemeName = exports.Enviroments = exports.GeolocationStatuses = exports.OfferingNames = exports.SupportedLanguages = exports.ProxyModeType = exports.OpeningMethod = exports.IntegrationMethod = exports.ApplicationMode = exports.AppStateEnum = exports.SDKStateEnum = exports.ClientPageType = exports.ScrollGames = exports.ActionID = exports.DeviceType = exports.PaymentAppType = exports.AppType = exports.SDKIdentifiers = exports.PageType = exports.LevelApp = exports.ProductPackageToID = exports.OpeningMode = exports.SupportedApplicationModes = exports.AppIdentifiers = exports.AreaType = exports.TriggerType = void 0;
var TriggerType;
(function (TriggerType) {
    TriggerType["automaticFlow"] = "automaticFlow";
    TriggerType["userSelection"] = "userSelection";
})(TriggerType || (exports.TriggerType = TriggerType = {}));
var AreaType;
(function (AreaType) {
    AreaType["email"] = "email";
    AreaType["button"] = "button";
    AreaType["banner"] = "banner";
    AreaType["externalClick"] = "externalClick";
    AreaType["tesetchannel"] = "tesetchannel";
    AreaType["UD"] = "UD";
    AreaType["Banner"] = "Banner";
    AreaType["ConfirmationScrean"] = "ConfirmationScreen";
    AreaType["Email"] = "Email";
    AreaType["HamburgerMenu"] = "Hamburger menu";
    AreaType["Header"] = "Header";
    AreaType["Message"] = "Message";
    AreaType["OMG"] = "OMG";
    AreaType["Overlay"] = "Overlay";
    AreaType["PCHeader"] = "PC Header";
    AreaType["PCLeftNavigationMenu"] = "PC Left navigation menu";
    AreaType["PendingAction"] = "Pending action";
    AreaType["Promotions"] = "Promotions";
    AreaType["SportBetslip"] = "Sport Betslip";
    AreaType["UserArea"] = "User area";
    AreaType["NavigationMenu"] = "Navigation menu";
    AreaType["StraightToCashier"] = "Straight to cashier";
    AreaType["InGame"] = "In game";
    AreaType["FullCashier"] = "Full Cashier";
})(AreaType || (exports.AreaType = AreaType = {}));
var AppIdentifiers;
(function (AppIdentifiers) {
    AppIdentifiers["FullCashier"] = "PAYMENTS_FULLCASHIER";
    AppIdentifiers["PokerBlast"] = "POKER_BLAST";
    AppIdentifiers["PokerGamesWidget"] = "POKER_GAMES_WIDGET";
    AppIdentifiers["PokerMockIframeWidget"] = "POKER_MOCK_IFRAME_WIDGET";
    AppIdentifiers["PokerMockWidget"] = "POKER_MOCK_WIDGET";
    AppIdentifiers["Redirect"] = "PAYMENTS_PSPREDIRECT";
    AppIdentifiers["SportKambi"] = "SPORT_KAMBICLIENT";
    AppIdentifiers["SportOffering"] = "SPORT_OFFERING";
    AppIdentifiers["SportSpectate"] = "SPORT_CLIENT";
    AppIdentifiers["SportPoker"] = "POKER_CLIENT";
    AppIdentifiers["TransactionHistory"] = "PAYMENTS_PLAYER_TRANSACTIONS_HISTORY";
    AppIdentifiers["UnifiedCashier"] = "PAYMENTS_DEPOSIT";
    AppIdentifiers["UnifiedClient"] = "UO_UNIFIEDCLIENT";
    AppIdentifiers["Unknown"] = "UNKNOWN";
    AppIdentifiers["Withdrawal"] = "PAYMENTS_WITHDRAWAL";
    AppIdentifiers["OpenBanking"] = "OPEN_BANKING";
    AppIdentifiers["CasinoClient"] = "CASINO_CLIENT";
    AppIdentifiers["UploadDocuments"] = "UPLOAD_DOCUMENTS";
    AppIdentifiers["UnifiedCashout"] = "PAYMENTS_CASHOUT";
    AppIdentifiers["OldChat"] = "CUSTOMERRELATIONS_CONTACT";
    AppIdentifiers["CustomerRelations"] = "CUSTOMERRELATIONS_CONTACT";
    AppIdentifiers["CRChat"] = "CR_CHAT";
    AppIdentifiers["CRChatBubble"] = "CR_CHAT_BUBBLE";
    AppIdentifiers["CRHelpCenter"] = "CR_HELP_CENTER";
    AppIdentifiers["CRMPromotions"] = "CRM_PROMOTIONS";
    AppIdentifiers["PokerHistory"] = "POKER_HISTORY";
    AppIdentifiers["UnifiedClientNative"] = "UO_UNIFIEDCLIENTNATIVE";
    AppIdentifiers["CasinoBonusGameWidget"] = "CASINO_BONUS_GAME_WIDGET";
    AppIdentifiers["OpenEmail"] = "OPEN_EMAIL";
    AppIdentifiers["OpenOnlineHelp"] = "OPEN_ONLINE_HELP";
    AppIdentifiers["ControlCenterFull"] = "RG_CONTROL_CENTER_FULL";
    AppIdentifiers["ControlCenterMini"] = "RG_CONTROL_CENTER_MINI";
    AppIdentifiers["PendingAction"] = "FUNNEL_PENDING";
    AppIdentifiers["Registration"] = "FUNNEL_REGISTRATION";
    AppIdentifiers["RgNotification"] = "RG_NOTIFICATION";
})(AppIdentifiers || (exports.AppIdentifiers = AppIdentifiers = {}));
var SupportedApplicationModes;
(function (SupportedApplicationModes) {
    SupportedApplicationModes["Proxy"] = "Proxy";
    SupportedApplicationModes["Full"] = "Full";
})(SupportedApplicationModes || (exports.SupportedApplicationModes = SupportedApplicationModes = {}));
var OpeningMode;
(function (OpeningMode) {
    OpeningMode["rightSideDrawer"] = "rightSideDrawer";
    OpeningMode["popup"] = "popup";
    OpeningMode["popupWindow"] = "popup with widgets background";
    OpeningMode["fullScreenPopup"] = "fullScreenPopup";
    OpeningMode["inClient"] = "inClient";
    OpeningMode["userArea"] = "userArea";
    OpeningMode["mainView"] = "mainView";
    OpeningMode["bubble"] = "bubble";
    OpeningMode["modal"] = "modal";
})(OpeningMode || (exports.OpeningMode = OpeningMode = {}));
var ProductPackageToID;
(function (ProductPackageToID) {
    ProductPackageToID[ProductPackageToID["FULL_CASHIER_PC"] = 11] = "FULL_CASHIER_PC";
    ProductPackageToID[ProductPackageToID["MEMBERSHIP"] = 14] = "MEMBERSHIP";
    ProductPackageToID[ProductPackageToID["PENDING"] = 27] = "PENDING";
    ProductPackageToID[ProductPackageToID["MOBILE_CASHIER"] = 69] = "MOBILE_CASHIER";
    ProductPackageToID[ProductPackageToID["FULL_CASHIER_MOBILE"] = 69] = "FULL_CASHIER_MOBILE";
    ProductPackageToID[ProductPackageToID["POKER_NATIVE_ANDROID_OOS"] = 122] = "POKER_NATIVE_ANDROID_OOS";
    ProductPackageToID[ProductPackageToID["POKER_NATIVE_ANDROID_IS"] = 124] = "POKER_NATIVE_ANDROID_IS";
    ProductPackageToID[ProductPackageToID["POKER_NATIVE_iOS"] = 126] = "POKER_NATIVE_iOS";
    ProductPackageToID[ProductPackageToID["CUSTOMER_RELATIONS"] = 131] = "CUSTOMER_RELATIONS";
    ProductPackageToID[ProductPackageToID["PAYMENTS_DEPOSIT"] = 133] = "PAYMENTS_DEPOSIT";
    ProductPackageToID[ProductPackageToID["PAYMENTS_PSPREDIRECT"] = 134] = "PAYMENTS_PSPREDIRECT";
    ProductPackageToID[ProductPackageToID["POKER_GAMES_WIDGET"] = 135] = "POKER_GAMES_WIDGET";
    ProductPackageToID[ProductPackageToID["POKER_BLAST_GAME"] = 136] = "POKER_BLAST_GAME";
    ProductPackageToID[ProductPackageToID["POKER_HISTORY"] = 138] = "POKER_HISTORY";
    ProductPackageToID[ProductPackageToID["CR_CHAT"] = 139] = "CR_CHAT";
    ProductPackageToID[ProductPackageToID["CR_CHAT_BUBBLE"] = 139] = "CR_CHAT_BUBBLE";
    ProductPackageToID[ProductPackageToID["CR_HELP_CENTER"] = 139] = "CR_HELP_CENTER";
    ProductPackageToID[ProductPackageToID["PAYMENTS_CASHOUT"] = 140] = "PAYMENTS_CASHOUT";
    ProductPackageToID[ProductPackageToID["PAYMENTS_PLAYER_TRANSACTIONS_HISTORY"] = 143] = "PAYMENTS_PLAYER_TRANSACTIONS_HISTORY";
    ProductPackageToID[ProductPackageToID["UNIFIED_CLIENT_NATIVE"] = 142] = "UNIFIED_CLIENT_NATIVE";
    ProductPackageToID[ProductPackageToID["REGISTRATION"] = 148] = "REGISTRATION";
    ProductPackageToID[ProductPackageToID["CRM_PROMOTIONS"] = 150] = "CRM_PROMOTIONS";
    ProductPackageToID[ProductPackageToID["OPEN_ONLINE_HELP"] = 9989] = "OPEN_ONLINE_HELP";
    ProductPackageToID[ProductPackageToID["OPEN_EMAIL"] = 9990] = "OPEN_EMAIL";
    ProductPackageToID[ProductPackageToID["OPEN_BANKING"] = 9991] = "OPEN_BANKING";
    ProductPackageToID[ProductPackageToID["UPLOAD_DOCUMENTS"] = 9992] = "UPLOAD_DOCUMENTS";
})(ProductPackageToID || (exports.ProductPackageToID = ProductPackageToID = {}));
var LevelApp;
(function (LevelApp) {
    LevelApp["Regular"] = "Regular";
    LevelApp["Critical"] = "Critical";
})(LevelApp || (exports.LevelApp = LevelApp = {}));
var PageType;
(function (PageType) {
    PageType["fullPage"] = "fullPage";
    PageType["virtualPage"] = "virtualPage";
})(PageType || (exports.PageType = PageType = {}));
var SDKIdentifiers;
(function (SDKIdentifiers) {
    SDKIdentifiers["UnifiedCashier"] = "UnifiedCashier";
    SDKIdentifiers["Poker"] = "PokerSDK";
    SDKIdentifiers["PokerBlastPoolWidget"] = "PokerBlastPoolWidget";
    SDKIdentifiers["UcMockWidget"] = "UcMockWidgetSDK";
    SDKIdentifiers["PokerHistory"] = "PokerHistory";
    SDKIdentifiers["CRChat"] = "CRChat";
    SDKIdentifiers["CRChatBubble"] = "CRChatBubble";
    SDKIdentifiers["CRHelpCenter"] = "CRHelpCenter";
    SDKIdentifiers["CRMPromotions"] = "CRMPromotions";
    SDKIdentifiers["ControlCenter"] = "ControlCenterSDK";
})(SDKIdentifiers || (exports.SDKIdentifiers = SDKIdentifiers = {}));
var AppType;
(function (AppType) {
    AppType["App"] = "App";
    AppType["Game"] = "Game";
})(AppType || (exports.AppType = AppType = {}));
var PaymentAppType;
(function (PaymentAppType) {
    PaymentAppType["FullCashier"] = "FullCashier";
    PaymentAppType["UnifiedCashier"] = "UnifiedCashier";
})(PaymentAppType || (exports.PaymentAppType = PaymentAppType = {}));
var DeviceType;
(function (DeviceType) {
    DeviceType[DeviceType["Unknown"] = 0] = "Unknown";
    DeviceType[DeviceType["SmartPhone"] = 1] = "SmartPhone";
    DeviceType[DeviceType["Tablet"] = 2] = "Tablet";
    DeviceType[DeviceType["PC"] = 3] = "PC";
    DeviceType[DeviceType["Phablet"] = 4] = "Phablet";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
exports.ActionID = {
    deposit: 'deposit',
    launcherAuth: 'launcherAuth',
    login: 'login',
    register: 'register',
    withdraw: 'withdraw',
    openPokerGame: 'openPokerGame',
    openPokerHistory: 'openPokerHistory',
    openChat: 'openChat',
    openHelp: 'openHelp',
    openBanking: 'openBanking',
    uploadDocumentsFromCashier: 'uploadDocumentsFromCashier',
    openClientPage: 'openClientPage',
    openLink: 'openLink',
    transactionHistory: 'transactionHistory',
    openEmail: 'openEmail',
    openOnlineHelp: 'openOnlineHelp',
    openAppPending: 'openAppPending',
    openCashier: 'openCashier',
    openSurvey: 'openSurvey',
    openBetslip: 'openBetslip',
    openChallenges: 'openChallenges',
    navigateClientPage: 'navigateClientPage',
    openPokerTournament: 'openPokerTournament',
    openMyAccount: 'openMyAccount',
    openRich: 'openRich',
    openCIS: 'openCIS',
    openCasino: 'openCasino',
    openControlCenterFull: 'openControlCenterFull',
    openControlCenterMini: 'openControlCenterMini',
    logout: 'logout',
    loginIntent: 'loginIntent',
    openCasinoGame: 'openCasinoGame',
    openForgotPassword: 'openForgotPassword',
    openCasinoFreeToPlay: 'openCasinoFreeToPlay',
    autoLogin: 'autoLogin',
    openPIS: 'openPIS',
    openPromotions: 'openPromotions',
    updateApp: 'updateApp',
    appRedirect: 'appRedirect',
    openNotification: 'openNotification',
};
var ScrollGames;
(function (ScrollGames) {
    ScrollGames["ring"] = "ringGame";
    ScrollGames["snap"] = "snapGame";
})(ScrollGames || (exports.ScrollGames = ScrollGames = {}));
var ClientPageType;
(function (ClientPageType) {
    ClientPageType["onlineHelp"] = "online-help";
    ClientPageType["rgPolicy"] = "rg-policy";
})(ClientPageType || (exports.ClientPageType = ClientPageType = {}));
var SDKStateEnum;
(function (SDKStateEnum) {
    SDKStateEnum["Loaded"] = "Loaded";
    SDKStateEnum["Error"] = "Error";
    SDKStateEnum["None"] = "None";
})(SDKStateEnum || (exports.SDKStateEnum = SDKStateEnum = {}));
var AppStateEnum;
(function (AppStateEnum) {
    AppStateEnum["ProxyMode"] = "ProxyMode";
    AppStateEnum["Opening"] = "Opening";
    AppStateEnum["Active"] = "Active";
    AppStateEnum["Overlayed"] = "Overlayed";
    AppStateEnum["Deactivated"] = "Deactivated";
    AppStateEnum["Covered"] = "Covered";
    AppStateEnum["Closed"] = "Closed";
    AppStateEnum["Error"] = "Error";
    AppStateEnum["Minimized"] = "Minimized";
    AppStateEnum["AlwaysOnTop"] = "AlwaysOnTop";
})(AppStateEnum || (exports.AppStateEnum = AppStateEnum = {}));
var ApplicationMode;
(function (ApplicationMode) {
    ApplicationMode["Full"] = "full";
    ApplicationMode["Proxy"] = "proxy";
    ApplicationMode["Mini"] = "mini";
})(ApplicationMode || (exports.ApplicationMode = ApplicationMode = {}));
var IntegrationMethod;
(function (IntegrationMethod) {
    IntegrationMethod["Div"] = "div";
    IntegrationMethod["IFrame"] = "iFrame";
})(IntegrationMethod || (exports.IntegrationMethod = IntegrationMethod = {}));
var OpeningMethod;
(function (OpeningMethod) {
    OpeningMethod["GNP"] = "GNP";
    OpeningMethod["UC"] = "UC";
})(OpeningMethod || (exports.OpeningMethod = OpeningMethod = {}));
var ProxyModeType;
(function (ProxyModeType) {
    ProxyModeType["UI"] = "ui";
    ProxyModeType["NoUI"] = "noUi";
})(ProxyModeType || (exports.ProxyModeType = ProxyModeType = {}));
var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["EN"] = "en";
    SupportedLanguages["PT"] = "pt";
    SupportedLanguages["FR"] = "fr";
    SupportedLanguages["ES"] = "es";
    SupportedLanguages["RU"] = "ru";
    SupportedLanguages["IT"] = "it";
    SupportedLanguages["DA"] = "da";
    SupportedLanguages["RO"] = "ro";
    SupportedLanguages["SV"] = "sv";
    SupportedLanguages["DE"] = "deu";
    SupportedLanguages["FI"] = "fi";
})(SupportedLanguages || (exports.SupportedLanguages = SupportedLanguages = {}));
var OfferingNames;
(function (OfferingNames) {
    OfferingNames["Poker"] = "Poker";
    OfferingNames["Casino"] = "Casino";
    OfferingNames["Sport"] = "Sport";
})(OfferingNames || (exports.OfferingNames = OfferingNames = {}));
var GeolocationStatuses;
(function (GeolocationStatuses) {
    GeolocationStatuses["NotStarted"] = "notStarted";
    GeolocationStatuses["InProgress"] = "inProgress";
    GeolocationStatuses["Success"] = "success";
    GeolocationStatuses["Failed"] = "failed";
})(GeolocationStatuses || (exports.GeolocationStatuses = GeolocationStatuses = {}));
var Enviroments;
(function (Enviroments) {
    Enviroments["Dev"] = "development";
    Enviroments["Prod"] = "production";
})(Enviroments || (exports.Enviroments = Enviroments = {}));
var ClientThemeName;
(function (ClientThemeName) {
    ClientThemeName["Poker888"] = "888poker";
    ClientThemeName["Casino888"] = "888casino";
    ClientThemeName["Sport888"] = "888sport";
    ClientThemeName["SI"] = "si";
    ClientThemeName["MrGreen"] = "mrgreen";
    ClientThemeName["Casino777"] = "777";
    ClientThemeName["WSOP"] = "wsop";
    ClientThemeName["Harrington"] = "harrington";
    ClientThemeName["Ballysdover"] = "ballysdover";
    ClientThemeName["Delawarepark"] = "delawarepark";
    ClientThemeName["Harrahs"] = "harrahs";
})(ClientThemeName || (exports.ClientThemeName = ClientThemeName = {}));
var ToastActionType;
(function (ToastActionType) {
    ToastActionType["Show"] = "show";
    ToastActionType["Dismiss"] = "dismiss";
    ToastActionType["Destroy"] = "destroy";
})(ToastActionType || (exports.ToastActionType = ToastActionType = {}));
var MessageActionType;
(function (MessageActionType) {
    MessageActionType["Show"] = "show";
    MessageActionType["Close"] = "close";
    MessageActionType["Confirmation"] = "confirmation";
    MessageActionType["Cancel"] = "cancel";
})(MessageActionType || (exports.MessageActionType = MessageActionType = {}));
var UserMode;
(function (UserMode) {
    UserMode["Authenticated"] = "Authenticated";
    UserMode["Anonymous"] = "Anonymous";
})(UserMode || (exports.UserMode = UserMode = {}));
var PersonalLimitsPopupType;
(function (PersonalLimitsPopupType) {
    PersonalLimitsPopupType["Toast"] = "Toast";
    PersonalLimitsPopupType["Popup"] = "Popup";
})(PersonalLimitsPopupType || (exports.PersonalLimitsPopupType = PersonalLimitsPopupType = {}));
var ElementType;
(function (ElementType) {
    ElementType["UD"] = "UD";
    ElementType["DepositButton"] = "Deposit button";
    ElementType["PlusButton"] = "Plus button";
})(ElementType || (exports.ElementType = ElementType = {}));
var SourceType;
(function (SourceType) {
    SourceType["UD"] = "UD";
    SourceType["UnifiedClient"] = "Unified Client";
    SourceType["MyAccount"] = "My account";
    SourceType["Registration"] = "Registration";
    SourceType["OMG"] = "OMG";
    SourceType["Promotions"] = "Promotions";
    SourceType["KambiSportClient"] = "Kambi Sport Client";
    SourceType["LandingPage"] = "Landing page";
    SourceType["PendingAction"] = "Pending action";
    SourceType["Bnaner"] = "Banner";
    SourceType["Email"] = "Email";
    SourceType["DeepLink"] = "Deeplink";
})(SourceType || (exports.SourceType = SourceType = {}));
var MyAccountTab;
(function (MyAccountTab) {
    MyAccountTab[MyAccountTab["ResponsibleGaming"] = 1] = "ResponsibleGaming";
    MyAccountTab[MyAccountTab["ChangePassword"] = 2] = "ChangePassword";
    MyAccountTab[MyAccountTab["Bonuses"] = 3] = "Bonuses";
    MyAccountTab[MyAccountTab["PersonalDetails"] = 4] = "PersonalDetails";
    MyAccountTab[MyAccountTab["InviteAFriend"] = 5] = "InviteAFriend";
    MyAccountTab[MyAccountTab["Reports"] = 6] = "Reports";
    MyAccountTab[MyAccountTab["LCChallenges"] = 7] = "LCChallenges";
    MyAccountTab[MyAccountTab["LCRedemption"] = 8] = "LCRedemption";
    MyAccountTab[MyAccountTab["Tournament"] = 10] = "Tournament";
    MyAccountTab[MyAccountTab["FreePlay"] = 11] = "FreePlay";
    MyAccountTab[MyAccountTab["FreeBets"] = 12] = "FreeBets";
    MyAccountTab[MyAccountTab["ComPoints"] = 13] = "ComPoints";
    MyAccountTab[MyAccountTab["MyChallenges"] = 16] = "MyChallenges";
    MyAccountTab[MyAccountTab["UploadDocuments"] = 18] = "UploadDocuments";
})(MyAccountTab || (exports.MyAccountTab = MyAccountTab = {}));
var CashierSessionType;
(function (CashierSessionType) {
    CashierSessionType[CashierSessionType["Deposit"] = 1] = "Deposit";
    CashierSessionType[CashierSessionType["TransactionHistory"] = 2] = "TransactionHistory";
    CashierSessionType[CashierSessionType["Withdraw"] = 4] = "Withdraw";
    CashierSessionType[CashierSessionType["ReverseWithdrawal"] = 6] = "ReverseWithdrawal";
    CashierSessionType[CashierSessionType["CashOutDepositHistory"] = 9] = "CashOutDepositHistory";
    CashierSessionType[CashierSessionType["FullCashier"] = 8] = "FullCashier";
    CashierSessionType[CashierSessionType["QuickDeposit"] = 16] = "QuickDeposit";
    CashierSessionType[CashierSessionType["VerifyId"] = 20] = "VerifyId";
})(CashierSessionType || (exports.CashierSessionType = CashierSessionType = {}));
var NativeAppType;
(function (NativeAppType) {
    NativeAppType["Sport"] = "sport";
    NativeAppType["Casino"] = "casino";
    NativeAppType["Poker"] = "poker";
})(NativeAppType || (exports.NativeAppType = NativeAppType = {}));
var EncryptionType;
(function (EncryptionType) {
    EncryptionType[EncryptionType["None"] = 1] = "None";
    EncryptionType[EncryptionType["MD5"] = 2] = "MD5";
    EncryptionType[EncryptionType["TEA"] = 3] = "TEA";
    EncryptionType[EncryptionType["XTinyEncryption"] = 4] = "XTinyEncryption";
    EncryptionType[EncryptionType["Token"] = 5] = "Token";
    EncryptionType[EncryptionType["TEA_MD5"] = 6] = "TEA_MD5";
    EncryptionType[EncryptionType["Nemo"] = 7] = "Nemo";
    EncryptionType[EncryptionType["TouchId"] = 8] = "TouchId";
    EncryptionType[EncryptionType["MitId"] = 9] = "MitId";
})(EncryptionType || (exports.EncryptionType = EncryptionType = {}));
var AuthenticationServiceType;
(function (AuthenticationServiceType) {
    AuthenticationServiceType["Regular"] = "regular";
    AuthenticationServiceType["Cross"] = "cross";
    AuthenticationServiceType["Biometrics"] = "biometrics";
    AuthenticationServiceType["Pending"] = "pending";
    AuthenticationServiceType["Registration"] = "registration";
    AuthenticationServiceType["Migration"] = "migration";
})(AuthenticationServiceType || (exports.AuthenticationServiceType = AuthenticationServiceType = {}));
var LifecycleEnum;
(function (LifecycleEnum) {
    LifecycleEnum[LifecycleEnum["Foreground"] = 1] = "Foreground";
    LifecycleEnum[LifecycleEnum["Background"] = 2] = "Background";
    LifecycleEnum[LifecycleEnum["Opening"] = 3] = "Opening";
    LifecycleEnum[LifecycleEnum["Closing"] = 4] = "Closing";
})(LifecycleEnum || (exports.LifecycleEnum = LifecycleEnum = {}));
var NativePermissionEnum;
(function (NativePermissionEnum) {
    NativePermissionEnum[NativePermissionEnum["Geolocation"] = 1] = "Geolocation";
})(NativePermissionEnum || (exports.NativePermissionEnum = NativePermissionEnum = {}));
var NativePluginStatus;
(function (NativePluginStatus) {
    NativePluginStatus["Enabled"] = "ENABLED";
    NativePluginStatus["Disabled"] = "DISABLED";
    NativePluginStatus["NoPermission"] = "NO_APP_PERMISSION";
})(NativePluginStatus || (exports.NativePluginStatus = NativePluginStatus = {}));
var GeolocationReason;
(function (GeolocationReason) {
    GeolocationReason["Login"] = "Login";
    GeolocationReason["Periodic"] = "Periodic";
    GeolocationReason["User"] = "User";
    GeolocationReason["Automatic"] = "Automatic";
})(GeolocationReason || (exports.GeolocationReason = GeolocationReason = {}));
var GamblingSessionStatus;
(function (GamblingSessionStatus) {
    GamblingSessionStatus[GamblingSessionStatus["Inactive"] = 0] = "Inactive";
    GamblingSessionStatus[GamblingSessionStatus["Active"] = 1] = "Active";
    GamblingSessionStatus[GamblingSessionStatus["Expired"] = 2] = "Expired";
    GamblingSessionStatus[GamblingSessionStatus["Restricted"] = 3] = "Restricted";
})(GamblingSessionStatus || (exports.GamblingSessionStatus = GamblingSessionStatus = {}));
//# sourceMappingURL=app-enums.js.map